import React from 'react';

// DEPENDENCIES
import { Alert, Container, Row, Col } from 'react-bootstrap';

export default function Error({ message }) {
  return (
    <Container>
      <Row className="justify-content-center">
        <Col xs={24} sm={16} lg={12}>
          <Alert variant="danger" className="mt-5 large text-center">
            {message}
          </Alert>
        </Col>
      </Row>
    </Container>
  );
}
